import * as pxp from 'lib/pxp'

// This treatment is to hide the end date, specifically for guest (GUID) flows
// like claim money.
// https://www.msmaster.qa.paypal.com/elmo/experiment/113517
// https://admin.paypalinc.com/elmo/experiment/103056
export function hasMgmHideEndDateTreatment() {
  return pxp.isTreatment('Trmt_p2p_web_mgm_hide_end_date')
}

// These treatments are used for access to MGM flow.
// https://www.msmaster.qa.paypal.com/elmo/experiment/111989
// https://admin.paypalinc.com/elmo/experiment/102880
export function hasMgmTreatmentTwo() {
  return pxp.isTreatment('Trmt_p2p_memeber_get_member_2')
}
export function hasMgmReferralLinksTreatment() {
  return pxp.isTreatment('Trmt_p2p_memeber_get_member_referral_link')
}

// These treatments below are variants of the success page mgm entry points
// https://www.msmaster.qa.paypal.com/elmo/experiment/113318
// https://admin.paypalinc.com/elmo/experiment/102928
export function hasMgmSuccessScreenEntryPointTreatment() {
  return pxp.isTreatment('Trmt_p2p_mgm_entry_point')
}
export function hasMgmSuccessScreenEntryPointTwoTreatment() {
  return pxp.isTreatment('Trmt_p2p_mgm_entry_point_2')
}
export function hasMgmSuccessScreenEntryPointThreeTreatment() {
  return pxp.isTreatment('Trmt_p2p_mgm_entry_point_3')
}

// https://www.msmaster.qa.paypal.com/elmo/experiment/113921
// https://admin.paypalinc.com/elmo/experiment/103330
export function hasMgmCustomNotesTreatment() {
  return pxp.isTreatment('TRMT_MGM_P2P_CUSTOM_NOTES_FIELD')
}

// https://www.msmaster.qa.paypal.com/elmo/experiment/114004
export function hasMgmPendingPayoutTreatment() {
  return pxp.isTreatment('TRMT_MGM_P2P_REFERRAL_DELAYED_PAYOUT_SCREEN')
}

// https://www.msmaster.qa.paypal.com/elmo/experiment/114045
export function hasMgmSideBarEntryPointTreatment() {
  return pxp.isTreatment('Trmt_p2p_mgm_entry_points')
}

export function hasMgmSideBarEntryPointTreatment2() {
  return pxp.isTreatment('Trmt_p2p_mgm_entry_points_2')
}
